import React, { useEffect, useState } from "react";
import { Menu, Button, Form, Input, Modal, Checkbox, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import countryList from "../../countryList";
import { filter, reverse } from "lodash";
import { DescriptionTwoTone } from "@material-ui/icons";
import searchEngine from "../../searchEngineList";
import {
  createKeywords,
  keywordModal,
} from "../../../store/actions/keywordActions";
import { updateTags } from "../../../store/actions/domainActions";
import TagsSelect from "../TagsSelect";
import AddKeywordStyles from "./AddKeywordStyles";
import LCButton from "../../styles/LCButton";

const AddKeywords = ({ title, shape, size }) => {
  const dispatcher = useDispatch();
  const domain = useSelector((state) => state.domains.currentDomain);
  const domains = useSelector((state) => state.domains.domains);
  const manualKeywordsModal = useSelector((state) => state.keywords.modal);
  const isLoading = useSelector((state) => state.config.disableButton);
  const keywordsObj = useSelector((state) => state.keywords);
  const currentUser = useSelector((state) => state.auth.user);
  const [keywordsImported, setkeywordsImported] = useState(0);
  const [manualKeywordsForm] = Form.useForm();

  const setmanualKeywordsModal = (visibility) => {
    dispatcher(keywordModal(visibility));
  };

  const KeywordsMenu = (
    <Menu>
      <Menu.Item onClick={() => setmanualKeywordsModal(true)}>
        Add Keyword(s)
      </Menu.Item>
      <Menu.Item>Import Keywords from CSV</Menu.Item>
    </Menu>
  );

  const searchEngineCheckBoxes = searchEngine.map((searchEngine) => {
    return (
      <Col span={6} key={searchEngine}>
        <AddKeywordStyles>
          <Checkbox value={searchEngine}>
            <img
              src={`/icons/${searchEngine}.svg`}
              alt={searchEngine}
              className="image"
            />
            <span style={{ textTransform: "capitalize" }}>{searchEngine}</span>
          </Checkbox>
        </AddKeywordStyles>
      </Col>
    );
  });

  const countryCheckBoxes = reverse(
    filter(countryList, (country) => {
      if (country.searchEngine) {
        return country;
      }
    })
  ).map((country) => {
    return (
      <Col span={8} key={country.value}>
        <AddKeywordStyles>
          <Checkbox value={country.value}>
            <img
              src={`/flags/${country.value}.png`}
              alt={country.value}
              className="image"
            />
            {country.text}
          </Checkbox>
        </AddKeywordStyles>
      </Col>
    );
  });

  const calculateKeywords = () => {
    const searchEngine = manualKeywordsForm.getFieldValue().searchEngine;
    const country = manualKeywordsForm.getFieldValue().country;
    const keywords = manualKeywordsForm.getFieldValue().keywords;
    if (searchEngine && country && keywords) {
      setkeywordsImported(
        searchEngine.length * country.length * keywords.split(/\n/).length
      );
    }
  };

  const onFinish = (values) => {
    let formattedKeywords = [];
    const domainId = domain._id;
    const searchEngines = values.searchEngine;
    const countries = values.country;
    const keywords = values.keywords.split(/\n/);
    const tags = values.tags;

    keywords.forEach((keyword) => {
      const trimKeyword = keyword.trim();
      searchEngines.forEach((searchEngine) => {
        countries.forEach((country) => {
          formattedKeywords.push({
            domain: domainId,
            keyword: trimKeyword,
            searchEngine: searchEngine,
            country: country,
            tags: tags,
          });
        });
      });
    });

    dispatcher(
      createKeywords(
        domainId,
        formattedKeywords,
        keywordsObj.pageNum,
        keywordsObj.search,
        keywordsObj.sort,
        keywordsObj.limit
      )
    );
    dispatcher(updateTags(domains, domainId, tags));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      {currentUser && currentUser.keywordLeft > 0 ? (
        <>
          <LCButton
            type="primary"
            addMargin
            as="button"
            onClick={() => setmanualKeywordsModal(true)}
          >
            {title}
          </LCButton>

          <Modal
            title="Add Keyword(s)"
            visible={manualKeywordsModal}
            onOk={() => manualKeywordsForm.submit()}
            onCancel={() => setmanualKeywordsModal(false)}
            okText="Save"
            keyboard={false}
            maskClosable={false}
            width={1200}
            okButtonProps={{
              loading: isLoading,
            }}
            cancelButtonProps={{
              loading: isLoading,
            }}
            footer={[
              <LCButton
                type="primary"
                as="button"
                addMargin
                onClick={() => setmanualKeywordsModal(false)}
              >
                Cancel
              </LCButton>,
              <LCButton
                type="secondary"
                as="button"
                addMargin
                onClick={() => manualKeywordsForm.submit()}
              >
                Save
              </LCButton>,
            ]}
          >
            <Form
              form={manualKeywordsForm}
              layout="vertical"
              name="addKeyworsForm"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <AddKeywordStyles>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  <Col className="gutter-row keywordsSection" span={12}>
                    <div className="sectionHeading">
                      <span className="tag">1</span>
                      <span className="headingText">Choose your keywords</span>
                    </div>
                    <Form.Item
                      name="keywords"
                      label="Add Keywords (Press enter after each keyword)"
                      rules={[
                        { required: true, message: "Please enter keyword(s)." },
                      ]}
                      onChange={calculateKeywords}
                      normalize={(value) => value.toLocaleLowerCase()}
                    >
                      <Input.TextArea rows={11} />
                    </Form.Item>
                    <p>
                      <strong>{keywordsImported}</strong> keywords will be
                      imported.
                    </p>
                    <LCButton type="primary" as="button">
                      <DescriptionTwoTone className="icon" /> CSV / Excel
                    </LCButton>
                  </Col>
                  <Col className="gutter-row sitesSection" span={12}>
                    <div className="sectionHeading">
                      <span className="tag">2</span>
                      <span className="headingText">
                        Choose search engine, location and tags
                      </span>
                    </div>
                    <TagsSelect showLabel />
                    <Form.Item
                      name="searchEngine"
                      label="Search Engine"
                      rules={[
                        {
                          required: true,
                          message: "Please select search engine.",
                        },
                      ]}
                    >
                      <Checkbox.Group
                        style={{ width: "100%" }}
                        onChange={calculateKeywords}
                      >
                        <Row>{searchEngineCheckBoxes}</Row>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item
                      name="country"
                      label="Country"
                      rules={[
                        { required: true, message: "Please select country." },
                      ]}
                    >
                      <Checkbox.Group onChange={calculateKeywords}>
                        <Row>{countryCheckBoxes}</Row>
                      </Checkbox.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </AddKeywordStyles>
            </Form>
          </Modal>
        </>
      ) : null}
    </>
  );
};

export default AddKeywords;
